import { AppColors, AppPalette, CustomPalette } from "@bpipartners/webui";

const appPalette: AppPalette = {
  primary: {
    "0": "#000000FF",
    "5": "#0D0119FF",
    "10": "#1A0132FF",
    "20": "#340066FF",
    "25": "#41037DFF",
    "30": "#4D0594FF",
    "35": "#570BA1FF",
    "40": "#6010AEFF",
    "50": "#782CC3FF",
    "60": "#9257CBFF",
    "70": "#9968CAFF",
    "80": "#B68DDEFF",
    "90": "#CBAFE9FF",
    "95": "#EDDBFDFF",
    "98": "#FBF3FEFF",
    "99": "#FFFBFEFF",
    "100": "#FFFFFFFF",
  },
  secondary: {
    "0": "#000000FF",
    "5": "#1A161EFF",
    "10": "#332B3BFF",
    "20": "#4D4554FF",
    "25": "#5A4F64FF",
    "30": "#665973FF",
    "35": "#736383FF",
    "40": "#806C93FF",
    "50": "#9A82B0FF",
    "60": "#B499CCFF",
    "70": "#BFACD2FF",
    "80": "#CCBDDBFF",
    "90": "#D8CDE4FF",
    "95": "#E6DBF0FF",
    "98": "#F9F3FBFF",
    "99": "#FFFBFEFF",
    "100": "#FFFFFFFF",
  },
  tertiary: {
    "0": "#000000FF",
    "5": "#271800FF",
    "10": "#4D2F00FF",
    "20": "#804D00FF",
    "25": "#995E00FF",
    "30": "#B26F00FF",
    "35": "#D98700FF",
    "40": "#FF9E00FF",
    "50": "#FFAC24FF",
    "60": "#FFBA49FF",
    "70": "#FFC86DFF",
    "80": "#FFD185FF",
    "90": "#FFDA9EFF",
    "95": "#FFE3B6FF",
    "98": "#FFF2DEFF",
    "99": "#FFF7EBFF",
    "100": "#FFFFFFFF",
  },
  neutral: {
    "0": "#07000EFF",
    "5": "#0F0D13FF",
    "10": "#262626FF",
    "20": "#444047FF",
    "25": "#3B383EFF",
    "30": "#4C4850FF",
    "35": "#5C5761FF",
    "40": "#686669FF",
    "50": "#717171FF",
    "60": "#888888FF",
    "70": "#B5B3B7FF",
    "80": "#CFCDD0FF",
    "90": "#E6E6E7FF",
    "95": "#F7F7F7FF",
    "98": "#FAF9FCFF",
    "99": "#FDFCFEFF",
    "100": "#FFFFFFFF",
  },
  neutralVariant: {
    "0": "#000000",
    "5": "#121017",
    "10": "#1D1A22",
    "20": "#322F37",
    "25": "#3E3A43",
    "30": "#49454E",
    "35": "#55515A",
    "40": "#615D66",
    "50": "#7A757F",
    "60": "#948F99",
    "70": "#AFA9B4",
    "80": "#CBC4CF",
    "90": "#E7E0EB",
    "95": "#F6EEFA",
    "98": "#FEF7FF",
    "99": "#FFFBFF",
    "100": "#FFFFFF",
  },

  error: {
    "0": "#000000",
    "5": "#2D0001",
    "10": "#410002",
    "20": "#690005",
    "25": "#7E0007",
    "30": "#93000A",
    "35": "#A80710",
    "40": "#BA1A1A",
    "50": "#DE3730",
    "60": "#FF5449",
    "70": "#FF897D",
    "80": "#FFB4AB",
    "90": "#FFDAD6",
    "95": "#FFEDEA",
    "98": "#FFF8F7",
    "99": "#FFFBFF",
    "100": "#FFFFFF",
  },
};

const appColors: AppColors = {
  primary: appPalette.primary[40],
  onPrimary: appPalette.primary[100],
  primaryContainer: appPalette.primary[90],
  onPrimaryContainer: appPalette.primary[10],
  secondary: appPalette.secondary[40],
  onSecondary: appPalette.secondary[100],
  secondaryContainer: appPalette.secondary[90],
  onSecondaryContainer: appPalette.secondary[10],
  tertiary: appPalette.tertiary[40],
  onTertiary: appPalette.tertiary[100],
  tertiaryContainer: appPalette.tertiary[90],
  onTertiaryContainer: appPalette.tertiary[10],
  error: appPalette.error[40],
  onError: appPalette.error[100],
  errorContainer: appPalette.error[90],
  onErrorContainer: appPalette.error[10],
  inversePrimary: appPalette.primary[80],
  primaryFixed: appPalette.primary[90],
  onPrimaryFixed: appPalette.primary[10],
  primaryFixedDim: appPalette.primary[80],
  onPrimaryFixedVariant: appPalette.primary[30],
  secondaryFixed: appPalette.secondary[90],
  onSecondaryFixed: appPalette.secondary[10],
  secondaryFixedDim: appPalette.secondary[80],
  onSecondaryFixedVariant: appPalette.secondary[30],
  tertiaryFixed: appPalette.tertiary[90],
  onTertiaryFixed: appPalette.tertiary[10],
  tertiaryFixedDim: appPalette.tertiary[80],
  onTertiaryFixedVariant: appPalette.tertiary[30],
  background: "#F4F5FC", //appPalette.neutral[98],
  onBackground: appPalette.neutral[5],
  outline: appPalette.neutral[50],
  outlineVariant: appPalette.neutral[80],
  shadow: appPalette.primary[0],
  scrim: appPalette.primary[0],
  inverseSurface: appPalette.neutralVariant[90],
  inverseOnSurface: appPalette.neutralVariant[10],
  surface: appPalette.neutral[95],
  onSurface: appPalette.neutral[10],
  surfaceVariant: appPalette.neutralVariant[95],
  onSurfaceVariant: appPalette.neutralVariant[10],
  surfaceDim: appPalette.neutral[70],
  surfaceBright: appPalette.neutral[100],
  surfaceContainerLowest: appPalette.neutral[99],
  surfaceContainerLow: appPalette.neutral[95],
  surfaceContainer: appPalette.neutral[90],
  surfaceContainerHigh: appPalette.neutral[80],
  surfaceContainerHighest: appPalette.neutral[70],
  backdrop: appPalette.primary[30],

  relation: { organization: "#0B79D0", person: "#C77700", tag: "#C51162" },
  planning: {},

  importance: {
    major: { fg: "#d82e18", bg: "#f2bdb4" },
    medium: { fg: "#db7c2e", bg: "#EAAF71" },
    normal: { fg: "#6b6f73", bg: "#edf1f4" },
    low: { fg: "#01a2fa", bg: "#c6e9ff" },
  },
  surfaceTint: "",
  timesheet: {
    green: "",
    orange: "",
  },
  customColors: {
    raportTableColors: {
      domain: appPalette.secondary[95],
      goal: appPalette.secondary[98],
      measurement: appPalette.secondary[99],
    },
    measurementLevels: {
      1: "#d82e18",
      2: "#db7c2e",
      3: "#CCA400",
      4: "#8FB302",
      5: "#3D9901",
    },
    widgetColors: {
      planning: { fg: "#2E7D32", bg: "#E8F5E9" },
      communication: { fg: "#db7c2e", bg: "#f5ead8" },
      library: { fg: "#c45a6a", bg: "#fdf0f3" },
      task: { fg: "#1565C0", bg: "#E3F2FD" },
    },
    taskColors: {
      overdue: {
        bg: "#FFF0EE",
        text: "#d82e18",
        border: "#d82e18",
      },
      in3Days: {
        bg: "#FFF5EB",
        text: "#db7c2e",
        border: "#db7c2e",
      },
      future: {
        bg: "#F3F0F9",
        text: appPalette.primary[70],
        border: appPalette.primary[50],
      },
    },
  },
};

export const colors: CustomPalette = {
  appColors,
  appPalette,
  palette: {
    DataGrid: {
      headerBg: appPalette.primary[95],
      pinnedBg: appPalette.primary[95],
      bg: appColors.surfaceBright,
    },
    background: {
      default: appColors.background,
      paper: appColors.surfaceBright,
    },
    primary: {
      light: appColors.primary,
      main: appPalette.primary[60],
      dark: appColors.primary,
      contrastText: appColors.onPrimary,
    },
    secondary: {
      light: appColors.secondary,
      main: appPalette.secondary[60],
      dark: appColors.secondary,
      contrastText: appColors.onSecondary,
    },
  },
};
